import React from 'react';
import './CodeWindow.css';

// Token helpers for the fake syntax highlighting
const K = ({ children }) => <span className="tk-key">{children}</span>;
const S = ({ children }) => <span className="tk-str">{children}</span>;
const F = ({ children }) => <span className="tk-fn">{children}</span>;
const C = ({ children }) => <span className="tk-com">{children}</span>;
const P = ({ children }) => <span className="tk-prop">{children}</span>;

const codeLines = [
  <C>{'// escr.config.ts'}</C>,
  <>
    <K>import</K> {'{ '}<F>ship</F>{' }'} <K>from</K> <S>'@escr/core'</S>
  </>,
  '',
  <>
    <K>export default</K> <F>ship</F>({'{'}
  </>,
  <>
    {'  '}<P>client</P>: <S>'you'</S>,
  </>,
  <>
    {'  '}<P>stack</P>: [<S>'react'</S>, <S>'node'</S>, <S>'aws'</S>],
  </>,
  <>
    {'  '}<P>quality</P>: <S>'production-grade'</S>,
  </>,
  <>
    {'  '}<P>deadline</P>: <S>'on time'</S>,
  </>,
  <>{'})'}</>,
];

const terminalLines = [
  { text: '$ escr deploy --prod', className: 'term-cmd' },
  { text: '✓ Compiled successfully', className: 'term-ok' },
  { text: '✓ All checks passed', className: 'term-ok' },
  { text: '→ Live at your-product.com', className: 'term-live' },
];

const CodeWindow = () => (
  <div className="code-window" role="img" aria-label="Code editor showing a project configuration and a successful production deploy">
    <div className="code-window-bar">
      <span className="dot red" />
      <span className="dot yellow" />
      <span className="dot green" />
      <span className="code-window-tab">escr.config.ts</span>
    </div>
    <pre className="code-window-body" aria-hidden="true">
      {codeLines.map((line, i) => (
        <span className="code-line" key={i} style={{ '--i': i }}>
          <span className="line-no">{i + 1}</span>
          <span>{line}</span>
        </span>
      ))}
    </pre>
    <div className="code-window-terminal" aria-hidden="true">
      {terminalLines.map((line, i) => (
        <span className={`term-line ${line.className}`} key={i} style={{ '--i': i + codeLines.length }}>
          {line.text}
        </span>
      ))}
      <span className="term-cursor" style={{ '--i': codeLines.length + terminalLines.length }} />
    </div>
  </div>
);

export default CodeWindow;
